/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_RelatedInputs */

const en_gc_guides_related = /** @type {(inputs: Gc_Guides_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep your curiosity going.`)
};

const zh_gc_guides_related = /** @type {(inputs: Gc_Guides_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带着好奇，继续探索。`)
};

/**
* | output |
* | --- |
* | "Keep your curiosity going." |
*
* @param {Gc_Guides_RelatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_related = /** @type {((inputs?: Gc_Guides_RelatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_RelatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_related(inputs)
	return zh_gc_guides_related(inputs)
});
export { gc_guides_related as "gc.guides.related" }